import './App.css';
import { Outlet } from "react-router-dom";
import {get, apiUrl} from './helpers/httpClient';
import { useState, useEffect } from 'react';
import getSocialIcon from './helpers/social';

function Layout() {
  const [navOpen, setNavOpen] = useState(false);
  const [website, setWebsite] = useState()
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    async function fetchWebsiteInfo() {
      try {
        const resp = await get('websites.json');
        if (resp) {
            setWebsite(resp);
        }
      } catch (error) {}
    }
    fetchWebsiteInfo();
  }, []);

  useEffect(() => {
    const closeNav = () => setNavOpen(false);
    window.addEventListener('popstate', closeNav);
    return () => window.removeEventListener('popstate', closeNav);
  }, []);

  return (
    <div className="App">
        {website &&
      <div className="app-container">
          <header className={`header${isScrolled ? ' header-hidden' : ''}${navOpen ? ' open' : ''}`}>
            <div className="header-container">
              <a href="/" className="logo">{website.title}</a>
              <button
                className={`burger${navOpen ? ' open' : ''}`}
                aria-label={navOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={navOpen}
                aria-controls="primary-navigation"
                onClick={() => setNavOpen(!navOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              <nav id="primary-navigation backColor" className={`nav${navOpen ? " open" : ""}`}>
                {website.menu.items.map((item, index) => (
                  <a
                    key={index}
                    href={'/' + item.slug}
                    className={window.location.pathname === '/' + item.slug ? 'active' : ''}
                    onClick={() => setNavOpen(false)}
                  >
                    {item.name}
                  </a>
                ))}
              </nav>
            </div>
          </header>

          <main className="main-content">
            <Outlet />
          </main>

          <footer className="footer">
            <div className="footer-container">
              <p>© {new Date().getFullYear()} {website.title}. All rights reserved.</p>
              <div className="social-links">
                {[...website.socials.items].sort((a, b) => {
                  const typeA = String(a.social || '').trim().toLowerCase();
                  const typeB = String(b.social || '').trim().toLowerCase();
                  const isPhoneA = typeA === 'phone' || typeA === 'tel';
                  const isPhoneB = typeB === 'phone' || typeB === 'tel';
                  if (isPhoneA && !isPhoneB) return 1;
                  if (!isPhoneA && isPhoneB) return -1;
                  return 0;
                }).map((item, idx) => {
                  const icon = getSocialIcon(item.social);
                  const type = String(item.social || '').trim().toLowerCase();
                  const isPhone = type === 'phone' || type === 'tel';
                  const isContact = type === 'email' || type === 'mail' || isPhone;
                  return (
                    <a key={idx} href={item.url} target="_blank" rel="noopener noreferrer" className="social-link">
                      {icon || item.social}
                      {isContact && (
                        <span className={isPhone ? 'phone-text' : ''} style={{ marginLeft: '0.5em' }}>{item.url}</span>
                      )}
                    </a>
                  );
                })}
              </div>
            </div>
          </footer>
      </div>
        }
    </div>
  );
}

export default Layout;
